import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import { mediaQueryDown } from 'components/utils/breakpoint'
import BodyText from 'components/Luxkit/Typography/BodyText'
import QuoteClosedIcon from 'components/Luxkit/Icons/custom/QuoteClosedIcon'
import QuoteOpenedIcon from 'components/Luxkit/Icons/custom/QuoteOpenedIcon'

const Root = styled.div`
  position: relative;
  width: 80%;
  padding-right: ${rem(40)};
  padding-left: ${rem(40)};

  & + & {
    margin-top: ${rem(25)};
  }

  ${mediaQueryDown.tablet} {
    width: 100%;
  }
`

const PositionedQuoteOpen = styled(QuoteOpenedIcon)`
  position: absolute;
  left: 0;
`

const Source = styled(BodyText)`
  margin-top: ${rem(5)};
`

const PositionedQuoteClose = styled(QuoteClosedIcon)`
  position: absolute;
  right: 0;
  bottom: ${rem(8)};
  margin-right: ${rem(40)};
`

interface Props {
  content?: string;
  source?: string;
}

function PropertyReview(props: React.PropsWithChildren<Props>) {
  const {
    content,
    source,
  } = props

  return (
    <Root>
      <PositionedQuoteOpen colour="primary"/>
      <BodyText variant="medium">{content}</BodyText>
      <Source variant="medium" weight="bold">- {source}</Source>
      <PositionedQuoteClose colour="primary"/>
    </Root>
  )
}

export default PropertyReview
